module.exports = __webpack_public_path__ + "e0106718/img/copy-icon.408fdb2d.svg";